/**
 * Handles submission of the form.
 */

/**
 * WordPress dependencies.
 */
import apiFetch from '@wordpress/api-fetch';
import { __ } from '@wordpress/i18n';

export default function handleSubmitDonationForm(formURL, formData, setFormData) {
	const url = new URL(formURL);

	setFormData({ loading: true, message: '' });

	const errorMessage = __('Sorry, there was an error with the submission. Please try again later.', 'dekode-profundo-forms');

	const {
		name,
		mobile,
		email,
	} = formData;

	apiFetch({
		path: '/dekode-profundo-form/v1/datacapture',
		method: 'POST',
		data: {
			url: formURL,
			name,
			mobile,
			email,
		},
	})
	.then((response) => {
		if ( response.redirect ) {
			/**
			 * Modify URLs from response before redirect.
			 * 
			 * Some redirect URLs in Profundo's response are relative,
			 * so we're using the form url to add the necessary hostname.
			 */
			let redirectUrl = response.redirect;

			if (0 === response.redirect.indexOf('/')) {
				redirectUrl = `${url.protocol}//${url.hostname}${redirectUrl}`;
			}

			window.location.href = redirectUrl;
		} else {
			setFormData({ loading: false, message: errorMessage });
		}
	})
	.catch((err) => {
		console.error(err);
		setFormData({ loading: false, message: errorMessage });
	});
}